import { Programmes } from "../data/Programme/Programmes";

export const getProgrammeBySlug = (slug) => Programmes.find((x) => x.slug === slug);

export const getProgrammeById = (id) => Programmes.find((x) => x.programmeId === id);

export const getJourneyBySlug = (profile, slug) => {
  const currentProgramme = getProgrammeBySlug(slug);
  const currentJourney = profile?.currentJourneys?.find(
    (x) => x.programmeId === currentProgramme?.programmeId
  );
  return currentJourney;
};

export const getJourneyAndProgrammeIds = (profile) =>
  profile?.currentJourneys?.map((x) => ({
    journeyId: x.id,
    programmeId: x.programmeId,
  }));

export const getProgrammeOverviewBySlug = (programmeOverviews, slug) => {
  const currentProgramme = getProgrammeBySlug(slug);
  const currentProgrammeOverview = programmeOverviews?.find(
    (x) => x.programme.id === currentProgramme?.programmeId
  );
  return currentProgrammeOverview;
};

export const getProgrammesByProgrammeIds = (programmeIds) =>
  Programmes.filter((x) => programmeIds.includes(x.programmeId));

export const getProgrammesByJourneyAndProgrammeIds = (journeyAndProgrammeIds) => {
  const programmeIds = journeyAndProgrammeIds.map((x) => x.programmeId);
  const programmes = getProgrammesByProgrammeIds(programmeIds);
  return programmes;
};
